import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

function NoData() {
	const { t } = useTranslation();

	return (
		<div className="w-100 d-flex flex-column justify-content-center align-items-center gap-3">
			<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('COMMON.NO_DATA')} />
		</div>
	);
}

export default NoData;
